import React from 'react'

import { PermissionChecker } from '../../session'
import { SETTINGS } from '../_services/services'
import { useModalData } from '../../../components/modals/ModalsContext'
import ControlledModal from '../../../components/modals/ControlledModal'
import ModalHeader from './ModalHeader'

const IntegrationTokenModalEdit = props => {
  const { service, integrationId, moveBackOnSuccess } = useModalData() || {}
  const serviceData = SETTINGS[service]
  const { Form } = serviceData || {}

  return (
    <ControlledModal width={'36rem'} {...props}>
      <PermissionChecker module="integration" name="edit">
        <ModalHeader />
        {Form && <Form service={service} integrationId={integrationId} moveBackOnSuccess={moveBackOnSuccess} />}
      </PermissionChecker>
    </ControlledModal>
  )
}

export default IntegrationTokenModalEdit
